import styled, {css} from "styled-components"

import Flex from "@irati/ui/src/Flex"

import {getPictureBorderSize} from "../helpers/position"

const SinglePictureWrapper = styled(Flex).attrs(() => ({justifyContent: "center", alignItems: "center"}))`
  border-radius: 50%;

  ${({singlePictureSize, theme}) => css`
    height: ${singlePictureSize + (getPictureBorderSize(singlePictureSize) * 2)}px;
    width: ${singlePictureSize + (getPictureBorderSize(singlePictureSize) * 2)}px;
    background-color: ${theme.colors.utility.white};
  `}
`

export default SinglePictureWrapper
